{{!-- RESPONSE --}}
{{!-- TEACHER'S RESPONSE TO A USER'S COMMENT--}}
{{!-- This always follows after the user's activity-item, giftcard div, and matching donor--}}
{{!-- Keep in sync with the matching section in proposalMessage.tmpl --}}
{{#each responses}}
	{{#if this.isDDM}}
		{{!-- Only show to the donor--}}
		{{#if ../../showDDM}}
			<div class="activity-response teacher-response fluid-container">
				<div class="col col8">
					<div class="action">
						{{{userAvatar this.author}}}
						<div class="activity-description">
							<a href="{{userPageURL this.author}}">{{this.author.teacherScreenName}}</a> responded
						</div>
					</div>
					{{#if this.message}}
						<div class="comment">
							{{{this.message}}}
						</div>
					{{/if}}
				</div>
			</div>
		{{/if}}
	{{else}}
		<div class="activity-response teacher-response fluid-container">
			<div class="col col8">
				<div class="action">
					{{{userAvatar this.author}}}
					<div class="activity-description">
						<a href="{{userPageURL this.author}}">{{this.author.teacherScreenName}}</a> responded
					</div>
				</div>
				{{#if this.message}}
					<div class="comment">
						{{{this.message}}}
					</div>
				{{/if}}
			</div>
		</div>
	{{/if}}
{{/each}}
{{#unless original.apiDonation}}
	{{#if isTeacher}}
		{{#unless original.hasResponse}}
			{{#if responses}}
				<div class="defaultMessageSent"><svg class="icon icon-check"><use xlink:href="/images/icon/icon-junior.svg#icon-check"></use></svg> We sent your prewritten thank you to this donor.</div>
			{{/if}}
			<a class="reply-button button-secondary small js-reply-button" data-original-id="{{original.id}}" data-original-author-salutation="{{escapeQuotes original.author.salutation}}" id="reply-button-{{original.id}}">Write a personalized note</a>
		{{/unless}}
	{{/if}}
{{/unless}}
{{!-- END TEACHER RESPONSE TO A USER COMMENT--}}
